// @vendor
const Immutable = require('immutable');

//@ constants
const {
    BROKER_CONTRACT_VALUE_TYPE,
    BROKER_CONTRACT_FUND_TYPE,
    BROKER_CONTRACT_PLAN_TYPE
} = require('constants/index');

const getContractAssociatedAccount = (immAccounts, contractAssociatedAccountNumber) =>  {
    let accountId;
    const associatedAccount = immAccounts.get('byId').filter((account, index) => {

        const accountNumber = account.getIn(['ibanComplex', 'codbban']);
        const isAssociatedAccount = accountNumber.substr(accountNumber.length - contractAssociatedAccountNumber.length) === contractAssociatedAccountNumber;
        if(isAssociatedAccount){
            accountId = index;
        }
        return isAssociatedAccount;
    });

    return Immutable.fromJS({
        associatedAccount,
        accountId
    })
}

const buildContactCenterContractsList = (immStocksContracts, immAccounts, contractTypesToShow = []) => {
    const contractsGroupedByAccount = {};
    let immAssociatedAccount;

    const filteredContracts = immStocksContracts.filter((immContract) => {
        return contractTypesToShow.includes(immContract.get('tipoContrato'))
    });

    filteredContracts.forEach((immContract) => {
        switch(immContract.get('tipoContrato')) {
            case BROKER_CONTRACT_PLAN_TYPE:
                immAssociatedAccount = getContractAssociatedAccount(immAccounts, immContract.getIn(['associatedAccount', 'numerodecuenta']));
                break;
            case BROKER_CONTRACT_FUND_TYPE:
                immAssociatedAccount = getContractAssociatedAccount(immAccounts, immContract.getIn(['associatedAccount', 'numeroContrato']));
                break;
            case BROKER_CONTRACT_VALUE_TYPE:
                const codBan = immContract.getIn(['associatedAccount', 'codBan']);
                immAssociatedAccount = getContractAssociatedAccount(immAccounts, codBan.trim());

                break;
        }

        const associatedAccount = immAssociatedAccount.get('associatedAccount');
        const accountId = immAssociatedAccount.get('accountId');
        const iban = associatedAccount.getIn([accountId, 'iban']).trim();
        const alias = associatedAccount.getIn([accountId, 'alias']).trim();
        const accountNameIban = `${alias} ${iban}`;

        if(!contractsGroupedByAccount.hasOwnProperty(accountNameIban)){
            contractsGroupedByAccount[accountNameIban] = [immContract];
        }
        else {
            contractsGroupedByAccount[accountNameIban].push(immContract)
        }
    });

    return Immutable.fromJS(contractsGroupedByAccount);
}

module.exports = {
    getContractAssociatedAccount,
    buildContactCenterContractsList
}
